import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import clsx from 'clsx';
import { isString } from 'lodash';

import BlIcon from 'components/icons/BlIcon';
import s from './styled';

const Panel = memo(function Panel(props) {
  const {
    children,
    icon,
    title,
    actions,
    topBetween,
    className,
    totalIcon,
    $circleIcon,
    ...rest
  } = props;

  return (
    <s.Paper className={clsx(className, 'Panel-root')} {...rest}>
      {(title || icon || topBetween || actions) && (
        <s.PanelTop className="Panel-top" $noChildren={!children}>
          <s.PanelTitle className="Panel-title">
            <s.PanelIcon className="PanelIcon" $circleIcon={$circleIcon}>
              <BlIcon icon={icon} fontSize="large" />
            </s.PanelIcon>
            {title && (
              <Typography
                className="PanelTitle-typography"
                variant="h6"
                component={isString(title) ? 'h6' : 'div'}
              >
                {title}
              </Typography>
            )}
          </s.PanelTitle>

          {topBetween}

          {actions && (
            <s.PanelActions className="Panel-actions">{actions}</s.PanelActions>
          )}
        </s.PanelTop>
      )}

      {children && (
        <s.PanelChildren className="Panel-children">{children}</s.PanelChildren>
      )}
      {totalIcon}
    </s.Paper>
  );
});

Panel.propTypes = {
  actions: PropTypes.node,
  children: PropTypes.node,
  totalIcon: PropTypes.node,
  icon: PropTypes.string,
  iconBg: PropTypes.string,
  iconRadius: PropTypes.string,
  title: PropTypes.node,
  className: PropTypes.string,
  titleData: PropTypes.node,
  topBetween: PropTypes.node,
  $circleIcon: PropTypes.bool,
};

export default Panel;
